// extracted by mini-css-extract-plugin
module.exports = {"container":"PluginNonInstalled_container__2mIcx","icon":"PluginNonInstalled_icon__10oUu"};